var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Create Run Sheet Route")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isResetLoad
    },
    on: {
      "update:active": function($event) {
        _vm.isResetLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.IsSelectPlanned) ? _c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.ViewPlannedList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "title": "View full screen"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.ViewPlannedMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map",
    attrs: {
      "title": "Planned Map view"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    class: {
      active: _vm.currentTab == 'Eligible Shipment List'
    },
    attrs: {
      "title": "Eligible",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.ShowEligibleShipmentList()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentNo),
      expression: "shipmentNo"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "shipmentNo"
    },
    domProps: {
      "value": (_vm.shipmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errShipmentNo),
      expression: "errShipmentNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errShipmentNo))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 submit-btn"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "updatebtn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.AddShipment()
      }
    }
  }, [_vm._v(" Insert Shipment ")])], 1), _vm._v("  \n                          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId),
      expression: "searchByShippingId"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ShippingId",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId)
    },
    on: {
      "keyup": _vm.SearchEligibledata,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [(_vm.searchByShippingId != '' || _vm.ShipmentCount != 1 && _vm.ShipmentCount != 0 && _vm.ActiveTabIndex == 0) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowEligibleShipmentList('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShipmentCount <= 1) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowEligibleShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bagin-dtl1"
  }, [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.EligibleTableColumns,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsCheckbox": false,
      "IsRemoveShipment": false,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    model: {
      value: (_vm.ShowEligibleShipmentModel),
      callback: function($$v) {
        _vm.ShowEligibleShipmentModel = $$v
      },
      expression: "ShowEligibleShipmentModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.eligiblepagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Unplanned Shipment List'
    },
    attrs: {
      "title": "Unplanned",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6 submit-btn"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "updatebtn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.CreateAddRoute()
      }
    }
  }, [_vm._v(" Create/Add to Route ")])], 1), _vm._v("  \n                          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId1),
      expression: "searchByShippingId1"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId1')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ShippingId",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId1)
    },
    on: {
      "keyup": _vm.SearchPlannedUnPlanneddata,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [(_vm.searchByShippingId1 != '' || _vm.ShipmentCount != 1 && _vm.ShipmentCount != 0 && _vm.ActiveTabIndex == 1) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShipmentCount <= 1) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bagin-dtl1"
  }, [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.UnPlannedTableColumns,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsCheckbox": false,
      "IsRemoveShipment": false,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    model: {
      value: (_vm.ShowUnplannedShipmentModel),
      callback: function($$v) {
        _vm.ShowUnplannedShipmentModel = $$v
      },
      expression: "ShowUnplannedShipmentModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.UnPLpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), (!_vm.PlannedMapView || _vm.PlannedListView) ? _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Planned Shipment List'
    },
    attrs: {
      "title": "Planned",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row route-allocationtabs col-md-12"
  }, [_c('div', {
    staticClass: "plannedTabList col-md-6",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "DeliveryStatus"
  }, [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'listview'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchPlannedAllocationPanel('listview')
      }
    }
  }, [_vm._v("Plan Shipments List")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'allocationview'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchPlannedAllocationPanel('allocationview')
      }
    }
  }, [_vm._v("Plan Allocation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId2),
      expression: "searchByShippingId2"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId2')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ShippingId",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId2)
    },
    on: {
      "keyup": _vm.SearchPlannedUnPlanneddata,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [(_vm.searchByShippingId2 != '' || _vm.ShipmentCount != 1 && _vm.ShipmentCount != 0 && _vm.ActiveTabIndex == 2) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShipmentCount <= 1) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 lineHeightCss",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "20px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "-30px",
      "margin-top": "20px"
    }
  }, [_c('b-form-fieldset', [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>",
      "right": _vm.routeLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      disabled: _vm.isCreate
    },
    attrs: {
      "options": _vm.routeList,
      "disabled": _vm.isCreate == true,
      "selected-option": _vm.routeItemObj,
      "name": "route",
      "placeholder": "Select route"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.routeId),
      callback: function($$v) {
        _vm.routeId = $$v
      },
      expression: "routeId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "updatebtn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.ViewPlanData()
      }
    }
  }, [_vm._v(" View Plan ")]), _vm._v(" "), _c('b-button', {
    staticClass: "updatebtn",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.confirmPlan()
      }
    }
  }, [_vm._v(" Confirm Plan ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.resetRoute()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]), _vm._v(" "), (!_vm.isSequenceNo) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.PlannedTableColumns,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsCheckbox": false,
      "IsRemoveShipment": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    on: {
      "removeShipmentFromRoute": _vm.removeShipmentFromRoute
    },
    model: {
      value: (_vm.ShowPlannedShipmentModel),
      callback: function($$v) {
        _vm.ShowPlannedShipmentModel = $$v
      },
      expression: "ShowPlannedShipmentModel"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSequenceNo) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.PlannedTableColumnsWithOrderNo,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsCheckbox": false,
      "IsRemoveShipment": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    on: {
      "removeShipmentFromRoute": _vm.removeShipmentFromRoute,
      "editSequenceNo": _vm.editSequenceNo
    },
    model: {
      value: (_vm.ShowPlannedShipmentModel),
      callback: function($$v) {
        _vm.ShowPlannedShipmentModel = $$v
      },
      expression: "ShowPlannedShipmentModel"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeId == ''),
      expression: "routeId == ''"
    }],
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.PLpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeId != ''),
      expression: "routeId != ''"
    }],
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.PLRTpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.PlannedMapView) ? _c('b-tab', {
    class: {
      active: _vm.currentTab == 'Planned Shipment List'
    },
    attrs: {
      "title": "Planned",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row route-allocationtabs col-md-12 mb-4"
  }, [_c('div', {
    staticClass: "plannedTabList col-md-6",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "DeliveryStatus"
  }, [_c('span', {
    staticClass: "Planned-tabs mb-2"
  }, [_c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'listview'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchPlannedAllocationPanel('listview')
      }
    }
  }, [_vm._v("Plan Shipments List")]), _vm._v(" "), _c('a', {
    staticClass: "delivey-btn",
    class: {
      'active': _vm.currentScreenTab == 'allocationview'
    },
    attrs: {
      "href": "javascript:void(0)",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchPlannedAllocationPanel('allocationview')
      }
    }
  }, [_vm._v("Plan Allocation")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "CheckboxFont col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PlannedRoutes),
      expression: "PlannedRoutes"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.ActualRoute == true || _vm.ShowSR == true || _vm.UnassignedRoutes == true,
      "name": "plannedRoutes",
      "id": "plannedRoutes"
    },
    domProps: {
      "checked": Array.isArray(_vm.PlannedRoutes) ? _vm._i(_vm.PlannedRoutes, null) > -1 : (_vm.PlannedRoutes)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.PlannedRoutes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PlannedRoutes = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.PlannedRoutes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PlannedRoutes = $$c
        }
      }, function($event) {
        return _vm.ShowAssignedToSRList()
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Planned Routes")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ActualRoute),
      expression: "ActualRoute"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": true,
      "name": "ActualRoute",
      "id": "ActualRoute"
    },
    domProps: {
      "checked": Array.isArray(_vm.ActualRoute) ? _vm._i(_vm.ActualRoute, null) > -1 : (_vm.ActualRoute)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ActualRoute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ActualRoute = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ActualRoute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ActualRoute = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Actual Routes")])])]), _vm._v(" "), _c('div', {
    staticClass: "CheckboxFont col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShowSR),
      expression: "ShowSR"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": true,
      "name": "ShowSR",
      "id": "ShowSR"
    },
    domProps: {
      "checked": Array.isArray(_vm.ShowSR) ? _vm._i(_vm.ShowSR, null) > -1 : (_vm.ShowSR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ShowSR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ShowSR = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ShowSR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ShowSR = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Show SR")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UnassignedRoutes),
      expression: "UnassignedRoutes"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.PlannedRoutes == true || _vm.ActualRoute == true || _vm.ShowSR == true,
      "name": "UnassignedRoutes",
      "id": "UnassignedRoutes"
    },
    domProps: {
      "checked": Array.isArray(_vm.UnassignedRoutes) ? _vm._i(_vm.UnassignedRoutes, null) > -1 : (_vm.UnassignedRoutes)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.UnassignedRoutes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.UnassignedRoutes = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.UnassignedRoutes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.UnassignedRoutes = $$c
        }
      }, function($event) {
        return _vm.ShowAssignedToSRList()
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Unassigned Routes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      tableFixHead2: true
    },
    staticStyle: {
      "height": "400px",
      "overflow-y": "auto",
      "padding-right": "10px",
      "padding-left": "0px"
    }
  }, [_c('table', {
    staticClass: "b-table table-bordered table-hover tbl datatables",
    class: {
      tableFixHead2: true
    },
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedRoutedata),
      expression: "selectedRoutedata"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedRoutedata) ? _vm._i(_vm.selectedRoutedata, null) > -1 : (_vm.selectedRoutedata)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectedRoutedata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectedRoutedata = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectedRoutedata = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectedRoutedata = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Assigned SR")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Re-assign SR")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Edit route")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [(_vm.AssignedToSRList.length > 0) ? _vm._l((_vm.AssignedToSRList), function(row) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRouteIds),
        expression: "selectedRouteIds"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row.routesmasterid,
        "checked": Array.isArray(_vm.selectedRouteIds) ? _vm._i(_vm.selectedRouteIds, row.routesmasterid) > -1 : (_vm.selectedRouteIds)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedRouteIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.routesmasterid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRouteIds = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedRouteIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRouteIds = $$c
          }
        }, function($event) {
          return _vm.setcheckbox($event, row.routesmasterid)
        }]
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.routename) + "  " + _vm._s("(") + " " + _vm._s(row.routesmasterid) + " " + _vm._s(")"))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.deliveryusername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "12px"
      },
      attrs: {
        "title": "Assign Route to SR"
      },
      on: {
        "click": function($event) {
          return _vm.EditReAssignSR(row.routesmasterid)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "12px"
      },
      attrs: {
        "title": "Edit Route"
      },
      on: {
        "click": function($event) {
          return _vm.EditRouteShipments(row.routesmasterid)
        }
      }
    })])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('l-map', {
    staticClass: "map",
    staticStyle: {
      "height": "400px",
      "width": "100%",
      "right": "5px",
      "left": "100%",
      "bottom": "0px"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "options": _vm.mapOptions
    },
    on: {
      "update:center": _vm.centerUpdate,
      "update:zoom": _vm.zoomUpdate
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": _vm.url
    }
  }), _vm._v(" "), _vm._l((_vm.Markers), function(item) {
    return _c('v-marker-cluster', {
      key: item.markers
    }, _vm._l((item.markers), function(item1) {
      return _c('l-marker', {
        key: item1.routeid,
        attrs: {
          "lat-lng": item1.latlng
        }
      }, [_c('l-tooltip', {
        attrs: {
          "options": {
            permanent: false,
            interactive: true
          }
        }
      }, [_c('li', [_c('strong', [_vm._v("SequenceNo :")]), _vm._v("\n                                        " + _vm._s(item1.SeqNo) + "\n                                      ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("ShippingId :")]), _vm._v("\n                                        " + _vm._s(item1.ShippingID) + "\n                                      ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("RouteId :")]), _vm._v("\n                                        " + _vm._s(item1.routeid) + "\n                                      ")])]), _vm._v(" "), _c('l-popup', [_c('li', [_c('strong', [_vm._v("Address :")]), _vm._v("  \n                                      " + _vm._s(item1.Address) + "\n                                    ")])])], 1)
    }), 1)
  }), _vm._v(" "), _vm._l((_vm.PolyLines), function(item) {
    return _c('l-polyline', {
      key: item.routeid,
      attrs: {
        "lat-lngs": item.points,
        "visible": item.visible,
        "color": item.color
      }
    })
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Assigned to SR",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.getAllocatedShipments()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.AssignedToSRLoader
    },
    on: {
      "update:active": function($event) {
        _vm.AssignedToSRLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#151B31",
      "font-size": "18px",
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.reloadAllocatedShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId3),
      expression: "searchByShippingId3"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId3')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search Shippingid",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId3)
    },
    on: {
      "keyup": _vm.SearchAllocatedShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId3 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [(_vm.searchByShippingId3 != '' || _vm.ShipmentCount != 1 && _vm.ShipmentCount != 0 && _vm.ActiveTabIndex == 3) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.getAllocatedShipments('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShipmentCount <= 1) ? _c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.getAllocatedShipments('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e()], 1)], 1)], 1), _vm._v("  \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 lineHeightCss",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-4 mt-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>",
      "right": _vm.routeLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      disabled: _vm.isCreate
    },
    attrs: {
      "options": _vm.routeList,
      "disabled": _vm.isCreate == true,
      "selected-option": _vm.routeItemObj1,
      "name": "route",
      "placeholder": "Select route"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.routeId1),
      callback: function($$v) {
        _vm.routeId1 = $$v
      },
      expression: "routeId1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj1,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.srId1),
      callback: function($$v) {
        _vm.srId1 = $$v
      },
      expression: "srId1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.resetRoute()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('load-table-template', {
    attrs: {
      "columns": _vm.AssignedToSRColumns,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsCheckbox": false,
      "IsRemoveShipment": true,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    on: {
      "removeShipmentFromRoute": _vm.removeShipmentFromRoute
    },
    model: {
      value: (_vm.ShowAssignedToSRShipmentModel),
      callback: function($$v) {
        _vm.ShowAssignedToSRShipmentModel = $$v
      },
      expression: "ShowAssignedToSRShipmentModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.Allocatedpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Create Add to Route",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeCreateAddRouteModel
    },
    model: {
      value: (_vm.CreateAddRouteModel),
      callback: function($$v) {
        _vm.CreateAddRouteModel = $$v
      },
      expression: "CreateAddRouteModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Create/Add to Route")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCreateAddRouteModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("Create/Add to Route")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isResetLoad
    },
    on: {
      "update:active": function($event) {
        _vm.isResetLoad = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreateRoute),
      expression: "!isCreateRoute"
    }],
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Route")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>",
      "right": _vm.routeLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      disabled: _vm.isCreate
    },
    attrs: {
      "options": _vm.routeList,
      "disabled": _vm.isCreate == true,
      "selected-option": _vm.routeItemObj2,
      "name": "route",
      "placeholder": "Select route"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.routeId2),
      callback: function($$v) {
        _vm.routeId2 = $$v
      },
      expression: "routeId2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreateRoute),
      expression: "!isCreateRoute"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "updatebtn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": [function($event) {
        _vm.isCreateRoute = false
      }, function($event) {
        return _vm.AllocateShipmentsToRoute()
      }]
    }
  }, [_vm._v(" Add Shipments ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreateRoute),
      expression: "!isCreateRoute"
    }],
    staticClass: "col-md-3 mr-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "updatebtn",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.isCreateRoute = true
      }
    }
  }, [_vm._v(" Create Route ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.resetRoute()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1), _vm._v(" "), (_vm.IsAllocateShip) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsAllocateShip && !_vm.isCreateRoute),
      expression: "IsAllocateShip && !isCreateRoute"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 S-E-Count"
  }, [(_vm.allocationErrorMsg.length > 0 || _vm.allocationSuccessMsg || _vm.IsAllocateShip) ? _c('div', [_c('span', {
    staticClass: "Succ-count"
  }, [_vm._v("Success Count : " + _vm._s(_vm.successAllocationCount))])]) : _vm._e(), _vm._v(" "), (_vm.allocationErrorMsg.length > 0) ? _c('div', [_c('span', {
    staticClass: "Err-count"
  }, [_vm._v("Error Count : " + _vm._s(_vm.errorAllocationCount))])]) : _vm._e(), _vm._v(" "), (_vm.allocationErrorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.allocationErrorMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreateRoute),
      expression: "isCreateRoute"
    }],
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Name :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteName),
      expression: "RouteName"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('RouteName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Route Name",
      "name": "RouteName"
    },
    domProps: {
      "value": (_vm.RouteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RouteName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteName')),
      expression: "errors.has('RouteName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('RouteName')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreateRoute),
      expression: "isCreateRoute"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticClass: "createRt-btn"
  }, [_c('b-button', {
    staticClass: "updatebtn",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.CreateRoute()
      }
    }
  }, [_vm._v(" Add New-Route ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.ClearRouteNameDelOpt()
      }
    }
  }, [_vm._v(" Reset ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreateRoute),
      expression: "isCreateRoute"
    }],
    staticClass: "col-md-4 mr-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticClass: "createRt-btn"
  }, [_c('b-button', {
    staticClass: "btn btn-primary mr-2",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.resetRoute()
      }
    }
  }, [_vm._v(" Back ")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-right": "5px",
      "padding-left": "0px"
    }
  }, [_c('b-tabs', {
    staticClass: "shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    class: {
      active: _vm.currentTab == 'Unplanned Shipment List'
    },
    attrs: {
      "title": "Unplanned Shipment List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.reloadUnplannedData('reload')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "470px",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#151B31",
      "font-size": "18px",
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.reloadUnplannedData('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Unplanned Shipment List"
    }
  })]), _vm._v("  \n                                          "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.ShipmentCount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId4),
      expression: "searchByShippingId4"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('searchByShippingId4')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId4)
    },
    on: {
      "keyup": _vm.SearchPlannedUnPlanneddata,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId4 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.ShowPlannedUnplannedShipments('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _vm._v("  \n                                        ")]), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.UnPlannedTableColumns,
      "IsEditSequenceNo": _vm.isEditSeq,
      "IsReload": _vm.IsReload,
      "IsCheckbox": true,
      "IsRemoveShipment": false,
      "Shipmentloader": _vm.Shipmentloader,
      "showShipmentsList": _vm.showShipmentsList
    },
    on: {
      "selectedItemdata": _vm.selectedItemdataEvent
    },
    model: {
      value: (_vm.ShowUnplannedShipmentModel),
      callback: function($$v) {
        _vm.ShowUnplannedShipmentModel = $$v
      },
      expression: "ShowUnplannedShipmentModel"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.UnPLpagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTablePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)], 1)])])], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeCreateAddRouteModel
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Create Add Route",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeReAssignedSRModel
    },
    model: {
      value: (_vm.EditReAssignSRModel),
      callback: function($$v) {
        _vm.EditReAssignSRModel = $$v
      },
      expression: "EditReAssignSRModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Re-Assign SR")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeReAssignedSRModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.EditReAssignSRModelLoader
    },
    on: {
      "update:active": function($event) {
        _vm.EditReAssignSRModelLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("Edit Re-Assign SR")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.EditReAssignSRModelLoader
    },
    on: {
      "update:active": function($event) {
        _vm.EditReAssignSRModelLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Route")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>",
      "right": _vm.routeLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      disabled: _vm.isCreate
    },
    attrs: {
      "options": _vm.routeList,
      "disabled": _vm.isCreate == true,
      "selected-option": _vm.routeItemObj3,
      "name": "route",
      "placeholder": "Select route"
    },
    on: {
      "select": _vm.selectRoute
    },
    model: {
      value: (_vm.routeId3),
      callback: function($$v) {
        _vm.routeId3 = $$v
      },
      expression: "routeId3"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeItemObj3.value),
      expression: "routeItemObj3.value"
    }],
    staticClass: "col-md-12 mt-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SR')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tripDayflag == 1 || _vm.tripDateFlag == true),
      expression: "tripDayflag == 1 || tripDateFlag== true"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please close existing trip from SR app.! ")])], 1)], 1), _vm._v(" "), (!_vm.IsSRNeedTrip) ? _c('div', {
    staticClass: "col-md-2 mr-2",
    staticStyle: {
      "bottom": "20px"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srId == false
    },
    on: {
      "click": function($event) {
        return _vm.clearTrip()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [(_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.startTripFlag == false || _vm.tripDayflag == 1 || _vm.tripDateFlag == true
    },
    on: {
      "click": function($event) {
        return _vm.startTrip()
      }
    }
  }, [_vm._v(_vm._s(_vm.tripTitle))]) : _vm._e(), _vm._v(" "), (_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srId == false
    },
    on: {
      "click": function($event) {
        return _vm.clearTrip()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), (_vm.tripTitle == 'Continue with existing trip' && _vm.IsSRNeedTrip) ? _c('div', [_c('span', {
    staticClass: "checkTripDate",
    staticStyle: {
      "font-size": "10px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v(" Trip Created Date : " + _vm._s(_vm.tripCreatedDate) + " ")])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.tripTitle == 'Start Trip' && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && tripTitle=='Start Trip' && IsSRNeedTrip"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 mt-2"
  }, [_vm._v("Select Vehicle Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-1"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-primary1 mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('bike')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" Bike")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('vehicle')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Vehicle")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType && IsSRNeedTrip"
    }],
    staticClass: "row mt-2"
  }, [((_vm.vehicleType == 'bike' && _vm.srVehicleList.length == 0) || _vm.isVehicleReplaced == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleNo),
      expression: "vehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "vehicleNo"
    },
    domProps: {
      "value": (_vm.vehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleNo),
      expression: "errVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srVehicleList,
      "selected-option": _vm.vehicleNoItemObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Open KM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleOpenKM),
      expression: "vehicleOpenKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Open KM",
      "name": "vehicleOpenKM"
    },
    domProps: {
      "value": (_vm.vehicleOpenKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleOpenKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleKm),
      expression: "errVehicleKm"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleKm))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vehicleType == 'bike' && _vm.srVehicleList.length > 0),
      expression: "vehicleType=='bike' && srVehicleList.length>0"
    }],
    staticClass: "col-md-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isVehicleReplaceCheck($event)
      }
    },
    model: {
      value: (_vm.isVehicleReplacedCheck),
      callback: function($$v) {
        _vm.isVehicleReplacedCheck = $$v
      },
      expression: "isVehicleReplacedCheck"
    }
  }, [_vm._v("Is Vehicle Replaced?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-4",
    staticStyle: {
      "top": "10px"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.vehicleNo == '' || _vm.vehicleOpenKM == ''
    },
    on: {
      "click": function($event) {
        return _vm.startAllocation(true)
      }
    }
  }, [_vm._v("Start Allocation")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.allocationLoader
    },
    on: {
      "update:active": function($event) {
        _vm.allocationLoader = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startAllocationFlag || !_vm.IsSRNeedTrip),
      expression: "startAllocationFlag || !IsSRNeedTrip"
    }],
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    },
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.fromId),
      callback: function($$v) {
        _vm.fromId = $$v
      },
      expression: "fromId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    on: {
      "click": function($event) {
        return _vm.MapRouteToSR()
      }
    }
  }, [_vm._v("Map-Route to SR")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsMaproute),
      expression: "IsMaproute"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.allocationErrorMsg.length > 0 || _vm.allocationSuccessMsg || _vm.IsMaproute) ? _c('div', [_c('span', {
    staticClass: "Succ-count"
  }, [_vm._v("Success Count : " + _vm._s(_vm.successAllocationCount))]), _vm._v(" "), _c('span', {
    staticClass: "Err-count"
  }, [_vm._v("Error Count : " + _vm._s(_vm.errorAllocationCount))])]) : _vm._e(), _vm._v(" "), (_vm.allocationErrorMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.allocationErrorMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e()])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConfirmLoad,
      "text": "Please wait confirm trip is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirmLoad = $event
      }
    }
  })], 1)])])], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeReAssignedSRModel
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm"
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorOpenKM),
      expression: "errorOpenKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorOpenKM))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == '' || _vm.openKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Remove Shipment"
    },
    on: {
      "hidden": _vm.closeRemoveShipmentModal
    },
    model: {
      value: (_vm.RemoveShipmentModal),
      callback: function($$v) {
        _vm.RemoveShipmentModal = $$v
      },
      expression: "RemoveShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alert!")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRemoveShipmentModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('center', [_c('p', [_vm._v("The Shipment will be removed from Route.")]), _vm._v(" "), _c('p', [_vm._v("Do you want to proceed?")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Reason :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    ref: "ReasonOption",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ReasonOption",
      "options": _vm.ReasonOptionList,
      "selected-option": _vm.ReasonOptionItemObj,
      "name": "ReasonOption",
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectReasonOption
    },
    model: {
      value: (_vm.ReasonOption),
      callback: function($$v) {
        _vm.ReasonOption = $$v
      },
      expression: "ReasonOption"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "dg-btn btn-Ok",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeRouteShipment
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "dg-btn btn-Cancel pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeRemoveShipmentModal
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Edit SequenceNo"
    },
    on: {
      "hidden": _vm.closeEditSequenceNoModal
    },
    model: {
      value: (_vm.EditSequenceNoModal),
      callback: function($$v) {
        _vm.EditSequenceNoModal = $$v
      },
      expression: "EditSequenceNoModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Sequence Number")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeEditSequenceNoModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Enter Sequence Number :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-first-order'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SequenceNo),
      expression: "SequenceNo"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('SequenceNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Sequence Number",
      "name": "SequenceNo"
    },
    domProps: {
      "value": (_vm.SequenceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SequenceNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SequenceNo')),
      expression: "errors.has('SequenceNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SequenceNo')))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "dg-btn btn-Ok",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.EditSequenceNo
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "dg-btn btn-Cancel pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeEditSequenceNoModal
    }
  }, [_vm._v("No")])])])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff3599b","hasScoped":false}!./src/views/components/RouteAllocation/RouteAllocation.html
// module id = 1270
// module chunks = 1